/**
 * Карта разделов приложения (DEV-1252).
 *
 * Отдельная ручка, а не поле в /me: ответ /me лежит в 30-секундном кэше
 * валидации токена и в кэшах интерцептора каждого сервиса, где per-app поле
 * кэшировалось бы неверно.
 */
import { apiClient } from '@/api'

export interface AppSectionDto {
  key: string
  /**
   * ⚠️ Именно snake_case: gateway auth маршалит proto-именами (`created_at`,
   * `sort_order`), а не lowerCamelCase. С полем sortOrder сортировка молча
   * давала NaN и держалась лишь на том, что сервер отдаёт уже упорядоченный
   * список — до первого изменения на бэкенде (DEV-1253).
   */
  sort_order: number
}

export interface ListMySectionsResponse {
  sections?: AppSectionDto[]
}

export const sectionsApi = {
  /**
   * GET /api/v1/auth/sections
   *
   * Пустой app трактуется сервером как crm, но передаём явно: мобильные
   * клиенты ходят в ту же ручку без параметра, и неявность там уместна,
   * а здесь приложение известно.
   */
  async listMySections(app = 'crm'): Promise<ListMySectionsResponse> {
    const response = await apiClient.get<ListMySectionsResponse>('/api/v1/auth/sections', {
      params: { app },
    })
    return response.data
  },
}
